import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItems } from '@app/shared/models/menu-items';
import { SharedService } from '@app/shared/services/shared.service';
import { SVGIcon, fileAscxIcon, fileIcon, fileTxtIcon, homeIcon } from '@progress/kendo-svg-icons';

@Component({
	selector: 'kpa-sidenav',
	templateUrl: './kpa-sidenav.component.html',
	styleUrl: './kpa-sidenav.component.scss',
})
export class KpaSidenavComponent implements OnInit {
	public homeSvg: SVGIcon = homeIcon;
	public sheetSvg: SVGIcon = fileAscxIcon;
	@Input() menuitems: MenuItems[];
	@Input() selectedId: string;
	@Output() stateChange = new EventEmitter();
	constructor(
		private router: Router,
		private sharedService: SharedService
	) {}
	ngOnInit() {
		if (this.selectedId) {
			this.router.navigate([this.selectedId]);
		}
		this.sharedService.menuItemClick$.subscribe((item) => {
			this.onMenuItemClick(item);
		});
	}
	onMenuItemClick(item: any) {
		this.selectedId = item.path;
		this.stateChange.emit({ selectedId: this.selectedId });
		this.router.navigate([item.path]);
	}

	handleStateChange(event: any) {
		this.stateChange.emit(event);
	}
}
